<script lang="ts">

  import {deleteAllSearchQueryStringParameter} from "../url";
  import {Button} from "sveltestrap";

  export let error: Error;
  let errMsg: string = error.message;
  let badParam: string = null;

  const THEME_MAP = {
    "error": {"color": "#e7b1b6", "icon": "bi bi-exclamation-octagon-fill"},
    //"error": {"color": "#e7b1b6", "icon": "bi bi-fire"},
    "notification": {"color": "#f1f3f3", "icon": "bi bi-bell-fill"},
    //"notification": {"color": "#f1f3f3", "icon": "bi bi-water"},
  }
  let errorType: "error" | "notification" = "error";
  $: currentTheme = THEME_MAP[errorType];

  // these errors should only be showing up if someone is manually messing with params or param values, or we need
  // to adjust the regex/list of params in common-access/access-search-service/src/main/java/gov/noaa/ncei/access/search/service/validator/GenericMultiValueMapValidator.java
  // Change the error names we don't have to do string matching to figure out which error we are working with.
  if (errMsg.includes("Bad query parameter")) {
    badParam = errMsg.split(":").pop()?.trim();
    errMsg = `Invalid Search: "${badParam}" is not a valid search option.`
    errorType = "error"
  }
  else if (errMsg.includes("Unknown query parameter")) {
    errMsg = "Invalid Search: One of the query parameter values contains an illegal character."
    errorType = "error"
  }
  else if (error.name === "NO_SEARCH_RESULTS") {
    // change the error card background to look more like a notification than an error
    errorType = "notification"
  }
  else if (errMsg.includes("Failed to fetch")) {
    errMsg = "Failed to fetch data, check your internet connection."
    errorType = "error"
  }

  function refresh(): boolean {
    location.reload();
    return false;
  }
</script>

<div id="error-container">
  <div id="error-card"
       style="display: flex; flex-direction: column; align-items: center; --card-bg: {currentTheme.color}">
    <i class={currentTheme.icon} style="font-size: 24px;"></i>
    <p class="custom-error-message">{errMsg}</p>
    <!-- Lenny Bruce is not afraid. -->
  </div>
  <hr />
  <h4>Please try the following:</h4>
  <ol>
    {#if badParam}
      <li>
        <Button class="p-0 align-baseline" color="link" on:click={() => {deleteAllSearchQueryStringParameter(badParam)}}>
          Click here to remove bad search option.
        </Button>
      </li>
    {:else}
      <li>
        <Button class="p-0 align-baseline" color="link" on:click={refresh}>
          Click here to try again.
        </Button>
      </li>
    {/if}
    <li>
      Contact Support at
      <span class="fa fa-envelope mr-1 alert-link" aria-hidden="true"></span>
      <a href="mailto:ncei.orders@noaa.gov">ncei.orders&#64;noaa.gov</a>
      or call us at
      <span class="fa fa-phone mr-1" aria-hidden="true"></span>
      <a href="tel:1-828-271-4800">1-828-271-4800</a>
    </li>
    <li>Check back later.</li>
  </ol>
</div>

<style>
  #error-card {
    display: flex;
    width: 45%;
    background-color: var(--card-bg);
    margin: 3vh auto;
    border-radius: 2vh;
    padding: 2vh;
  }

  #error-container #error-card .custom-error-message {
    font-size: clamp(1rem, 2vw, 1.5rem);
    margin: auto;
    text-align: center;
  }
</style>
